import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20digital%20entertainment%20abstract%20background%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20orange%20and%20golden%20yellow%20tones%2C%20subtle%20geometric%20particle%20effects%2C%20dark%20elegant%20atmosphere%2C%20cinematic%20lighting%2C%20abstract%20technology%20feel%2C%20luxurious%20and%20energetic%20mood%2C%20wide%20banner%20composition&width=1920&height=1080&seq=hero-bg-91douyin&orientation=landscape"
          alt="91抖音短视频娱乐平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 font-heading">
          发现精彩短视频<br />
          <span className="text-primary-400">记录每一刻美好</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          91抖音汇聚海量热门视频、达人创作与潮流内容。舞蹈、搞笑、美食、旅行、音乐、时尚……找到属于你的精彩世界。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#download" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all hover:scale-105">
            <i className="ri-download-2-line text-lg"></i>
            立即下载APP
          </a>
          <Link to="/category/dance" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-background-300/40 text-background-50 text-base font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-all">
            <i className="ri-play-circle-line text-lg"></i>
            在线浏览
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-14">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">5亿+</p>
            <p className="text-xs md:text-sm text-background-300/70 mt-1">累计注册用户</p>
          </div>
          <div className="w-px h-10 bg-background-300/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">8000万+</p>
            <p className="text-xs md:text-sm text-background-300/70 mt-1">日均活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-300/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">1000万+</p>
            <p className="text-xs md:text-sm text-background-300/70 mt-1">日均新增视频</p>
          </div>
        </div>
      </div>
    </section>
  );
}